/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle/4-B': {
    width: 56,
    height: 56,
    viewBox: '0 0 56 56',
    data: '<path pid="0" d="M0 0h56v56H0V0zm28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28zm0-3C14.193 53 3 41.807 3 28S14.193 3 28 3s25 11.193 25 25-11.193 25-25 25zm.858-20.168V36h2.64v-3.168h2.266v-2.376h-2.266V20.424h-2.992l-6.27 9.79v2.618h6.622zm0-8.668v6.292H24.92l3.894-6.292h.044z" _fill="#D8D8D8" fill-rule="nonzero"/>'
  }
})
